import React from 'react';

const CouponSection = ({
  couponCode,
  setCouponCode,
  appliedCoupon,
  couponLoading,
  couponMessage,
  couponMessageType,
  onApplyCoupon,
  onRemoveCoupon,
  translations,
  selectedPlan,
  couponDisabled
}) => {
  return (
    <div style={{ marginBottom: "15px" }}>
      <label
      className="form-check-label terms-label" htmlFor="couponCode"
      >
        {translations.couponCode}
      </label>
      <div style={{ 
        display: "flex", 
        gap: "8px", 
        flexWrap: "wrap",
        '@media (max-width: 768px)': {
          flexDirection: 'column'
        }
      }}>
        <input
          type="text"
          placeholder={translations.couponCodePlaceholder}
            className="form-control"
          value={couponCode}
          onChange={(e) => setCouponCode(e.target.value)}
          disabled={appliedCoupon !== null || couponDisabled}
          style={{
            flex: 1,
            minWidth: "200px",
            padding: "10px 12px",
            border: "1px solid #e5e7eb",
            borderRadius: "8px",
            fontSize: "14px",
            fontFamily:
              "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
            outline: `${
              couponCode.trim()
                ? "0.5px solid rgb(37, 99, 235)"
                : "none"
            }`,
            opacity: couponDisabled ? 0.5 : 1,
            '@media (max-width: 768px)': {
              width: '100%',
              minWidth: 'auto'
            }
          }}
        />
        <button
          onClick={onApplyCoupon}
          disabled={couponLoading || appliedCoupon !== null || couponDisabled}
          style={{
            padding: "10px 20px",
            backgroundColor: "#2563eb",
            color: "white",
            border: "none",
            borderRadius: "8px",
            fontSize: "14px",
            fontWeight: "700",
            cursor:
              couponLoading || appliedCoupon !== null || couponDisabled
                ? "not-allowed"
                : "pointer",
            opacity: couponLoading || appliedCoupon !== null || couponDisabled ? 0.7 : 1,
            fontFamily:
              "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
            whiteSpace: "nowrap",
          }}
        >
          {couponLoading ? (
            <span
              style={{
                display: "inline-block",
                width: "14px",
                height: "14px",
                border: "2px solid transparent",
                borderTop: "2px solid white",
                borderRadius: "50%",
                animation: "spin 1s linear infinite",
              }}
            />
          ) : appliedCoupon ? (
            translations.discountApplied
          ) : (
            translations.applyCoupon
          )}
        </button>
        {/* Remove Coupon Button */}
        {appliedCoupon && (
          <button
            onClick={onRemoveCoupon}
            style={{
            padding: "10px 20px",
              backgroundColor: "#e5e7eb",
              color: "#374151",
              border: "none",
              borderRadius: "8px",
              fontSize: "14px",
              fontWeight: "700",
              cursor: "pointer",
              fontFamily:
                "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
              whiteSpace: "nowrap",
            }}
            type="button"
          >
            {translations.removeCoupon || "Remove"}
          </button>
        )}
      </div>

      {couponMessage && (
        <div
         className='coupon_message'
          style={{
            marginTop: "8px",
            padding: "10px 12px",
            backgroundColor:
              couponMessageType === "success" ? "#f0f9ff" : "#fef2f2",
            border: `1px solid ${
              couponMessageType === "success" ? "#bae6fd" : "#fecaca"
            }`,
            borderRadius: "6px",
            fontSize: "13px",
            color:
              couponMessageType === "success" ? "#0c4a6e" : "#dc2626",
          }}
        >
          {couponMessageType === "success" ? "✅" : "❌"}
          {couponMessage.includes(translations.couponApplied) ? (
            <span>
              "{appliedCoupon?.code}" {translations.discountApplied}! {translations.discountedPrice}:
              <span
                style={{
                  fontWeight: "bold",
                  color: "rgb(37, 99, 235)",
                }}
              >
                {selectedPlan?.currencySymbol}
                {appliedCoupon?.discountedAmount}
              </span>
            </span>
          ) : (
            couponMessage
          )}
        </div>
      )}
    </div>
  );
};

export default CouponSection;